import AddClientForm from '@/Pages/Admin/Clients/AddClientForm';

export default function AddClient(props) {
	return <AddClientForm {...props} submitDestination="new-policy" handleCloseBtn={() => window.history.back()} />;
}
